import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { BackendService, NotificationService, ModalService } from 'beyond-util';

import { SifarnikBase } from '../sifarnici/sifarnik-base/sifarnik-base';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-arianna-gledanost-emisije',
  templateUrl: './arianna-gledanost-emisije.component.html',
})
export class AriannaGledanostEmisijeComponent extends SifarnikBase {
  public url: SafeResourceUrl;

  constructor(
    protected _backendService: BackendService,
    protected _notificationService: NotificationService,
    protected _modalService: ModalService,
    private _sanitizer: DomSanitizer
  ) {
    super(_backendService, _modalService, _notificationService);

    this.url = this.getSantizedURL();
  }

  getSantizedURL() {
    const token = sessionStorage.getItem('token');

    return this._sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.ariannaGledanostEmisijeUrl}?token=${token}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/arianna-gledanost-emisije/arianna-gledanost-emisije.component.ts